export default __webpack_public_path__ + "static/media/2036.0ea31f79.png";